import { useCallback, useEffect } from 'react'

/**
 * This is a custom component that bootstraps Shopify's Accelerated Checkout functionality
 * https://shopify.dev/docs/api/liquid/objects/additional_checkout_buttons
 *
 * When the page loads, we clone the additional checkout buttons into an entrypoint to be displayed
 * in the cart drawer, in addition to the checkout button.
 * If there are available payment options for the current market, customers can use these options to
 * complete their purchase without using the Shopify checkout flow.
 */
export const AdditionalCheckoutButtons: React.FC = () => {
  const entrypointId = 'additional-checkout-buttons-entrypoint'
  const sourceId = 'additional-checkout-buttons'
  const clonedId = 'additional-checkout-buttons-cloned'

  const cloneAdditionalCheckoutButtons = useCallback(() => {
    const entrypoint = document.getElementById(entrypointId)
    const sourceContainer = document.getElementById(sourceId)

    if (!entrypoint || !sourceContainer) {
      console.error('Cannot clone AdditionalCheckoutButtons', {
        entrypointExists: !!entrypoint,
        sourceContainerExists: !!sourceContainer,
      })
      return
    }

    // Avoid cloning if we've already cloned the container
    if (entrypoint.querySelector(`#${clonedId}`)) {
      return
    }

    const clonedContainer = sourceContainer.cloneNode(true) as HTMLDivElement
    clonedContainer.classList.remove('hidden')
    clonedContainer.id = clonedId

    entrypoint.appendChild(clonedContainer)
  }, [])

  useEffect(() => {
    cloneAdditionalCheckoutButtons()
  }, [cloneAdditionalCheckoutButtons])

  return <div id={entrypointId} />
}
